import { DELSETELINKEDOBJECTIVE_SUCCESS, DELSETELINKEDOBJECTIVE_FAIL } from '../actionTypes';

const initialState = {
    user: null,
};

const deleteLinkedObjectiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELSETELINKEDOBJECTIVE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELSETELINKEDOBJECTIVE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default deleteLinkedObjectiveReducer;
